// @flow

import { get } from "./helpers";
import Config from "../constants/Config";

export const getAutoSuggestions = async (query: string): Promise<any> => {
    const queryParam = window.globalData.search.autocomplete.parameter;
    const url = `${Config.searchAutoSuggestionAPI}?${queryParam}=${query}`;
    return get(url);
};

export default {
    getAutoSuggestions,
};
